import React from "react";

export default class NotFound extends React.Component{
   constructor(props){
      super(props);
   }
   render(){
      return(
        <div style={{marginTop:"100px", minHeight:"70vh"}}>
            <div className = "container">
                <h2 style={{color:"red"}}> Errore 404, la pagina non è disponibile.</h2>
            </div>
        </div>
      );
   }
}